import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'product-badge',
  templateUrl: './product-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductBadgeComponent {}
